// extracted by mini-css-extract-plugin
export default {"container":"constructor-component_container__yY5w-","image":"constructor-component_image__W5nmz","card":"constructor-component_card__Crtdu"};